import { render, staticRenderFns } from "./FolderTree.vue?vue&type=template&id=2c8d3014&"
import script from "./FolderTree.vue?vue&type=script&lang=ts&"
export * from "./FolderTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports